import React, { Component } from 'react';
import { MARKETING_MODAL, PAYROLL_MODAL } from '../../redux/reducers/modal';
import MarketingStatsModal from '../blocks/marketing/MarketingStatsModal';
import ReduxModal from '../blocks/modal/ReduxModal';
import MainNav from '../blocks/navigation/MainNav';
import PayrollGeneratorModal from '../blocks/payroll/PayrollGeneratorModal';
import OvertimeReportContent from '../blocks/reports/OvertimeReportContent';
import RangedReportsContent from '../blocks/reports/RangedReportsContent';
import ReportsContent from '../blocks/reports/ReportsContent';
import TabsSwitcher from '../blocks/TabsSwitcher';
import type { Project, Router, User } from '../../types';

type State = {
  activeTab: string,
};

type Props = {
  projects: Array<Project>,
  currentUser: User,
  onGetReportData: Function,
  router: Router,
  openModal: Function,
  closeModal: Function,
};

class Reports extends Component<Props, State> {
  state = {
    activeTab: 'reports',
  };

  componentDidMount() {
    this.props.onGetReportData();
  }

  handleTabChange = (activeTab: string) => {
    this.setState({ activeTab });
  };

  handlePayrollGeneratorClick = () => {
    const { openModal } = this.props;
    openModal({ id: PAYROLL_MODAL });
  };

  handlePayrollModalClose = () => {
    const { closeModal } = this.props;
    closeModal({ id: PAYROLL_MODAL });
  };

  handleMarketingStatsClick = () => {
    const { openModal } = this.props;
    openModal({ id: MARKETING_MODAL });
  };

  handleMarketingModalClose = () => {
    const { closeModal } = this.props;
    closeModal({ id: MARKETING_MODAL });
  };

  render(): React.ReactNode {
    const { projects, currentUser, router } = this.props;
    const { activeTab } = this.state;

    return (
      <div className="reports-view container-view view-wrapper">
        <MainNav
          currentUser={currentUser}
          navigate={router.navigate}
          onPayrollGeneratorClick={this.handlePayrollGeneratorClick}
          onMarketingStatsClick={this.handleMarketingStatsClick}
        />
        <div className="m-5">
          <TabsSwitcher
            tabs={{ reports: 'Monthly Reports', ranged_reports: 'Ranged reports', overtime: 'Overtime' }}
            onTabCange={this.handleTabChange}
          />
        </div>
        {activeTab === 'reports' && (
          <ReportsContent
            projects={projects}
          />
        )}
        {activeTab === 'ranged_reports' && (
          <RangedReportsContent
            projects={projects}
          />
        )}
        {activeTab === 'overtime' && (
          <OvertimeReportContent />
        )}
        <ReduxModal id={PAYROLL_MODAL}>
          <PayrollGeneratorModal
            onCloseModal={this.handlePayrollModalClose}
          />
        </ReduxModal>
        <ReduxModal id={MARKETING_MODAL}>
          <MarketingStatsModal
            onCloseModal={this.handleMarketingModalClose}
          />
        </ReduxModal>
      </div>
    );
  }
}

export default Reports;
